import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'
import { useHelpCenterUrl } from 'shared/hooks/useHelpCenterUrl'

export function OnboardingInsuranceHelpButton() {
  const insuranceHelpUrl = useHelpCenterUrl('insurance-requirements')
  return <ExternalLink href={insuranceHelpUrl}>Need insurance? Apply</ExternalLink>
}
